

import { DocumentType, LoanPhaseCategoryType, RecentSearch, RecentSearchDto, SearchResultSubsectionType, SearchResultV2Dto, SearchSectionType } from 'src/backend';

import { baseApi } from './baseApi';


export const searchApi = baseApi.enhanceEndpoints({ addTagTypes: ['SearchResultV2Dto', 'RecentSearch'] }).injectEndpoints({
    endpoints: (build) => ({
        getGlobalSearch: build.query<SearchResultV2Dto, {
            q: string;
            sectionType?: SearchSectionType;
            subsectionType?: SearchResultSubsectionType;
            loanId?: string;
            pageNumber?: number;
            shoeboxOwnerId?: string;
            pageSize?: number;
            documentType?: DocumentType;
            phaseCategory?: LoanPhaseCategoryType;
        }>({
            query: (data) => ({
                url: '/v2/search',
                method: 'GET',
                data
            }),
            providesTags: ['SearchResultV2Dto'],
        }),
        saveRecentSearch: build.mutation<void, RecentSearchDto>({
            query: (data) => ({
                url: '/v2/search/recent',
                method: 'POST',
                data
            }),
            invalidatesTags: ['RecentSearch'],
        }),
        getRecentSearch: build.query<RecentSearch[], { loanId?: string; }>({
            query: (data) => ({
                url: '/v2/search/recent',
                method: 'GET',
                data
            }),
            providesTags: ['RecentSearch'],
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetGlobalSearchQuery,
    useLazyGetGlobalSearchQuery,
    useSaveRecentSearchMutation,
    useGetRecentSearchQuery,
} = searchApi;
